<script setup lang="ts">
import { defineEmits } from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineEmits(["clicked"]);
</script>

<template>
  <button
    class="group relative flex items-center h-8 w-8 md:h-[44px] md:w-[164px] md:px-[5px] rounded-full border border-brown text-brown font-medium text-base leading-[20px]"
    @click="$emit('clicked')"
  >
    <!-- ARROW ICON -->
    <span
      class="size-8 md:size-[34px] flex items-center justify-center rounded-full bg-brown"
    >
      <ArrowIcon class="text-white -rotate-[135deg]" />
    </span>

    <!-- TEXT -->
    <span class="flex-1 hidden md:block">
      <slot name="back-text">
        {{ t("buttons.back") }}
      </slot>
    </span>
  </button>
</template>
